import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../Global.css";
import Happiness_Slides from "../Resources/ML_Happiness_Slides.pdf";
import Price_Anchoring from "../Resources/Price_Anchoring.pdf";
import PA_Slides from "../Resources/Price_Anchor_Slides.pdf";
import SB_Slides from "../Resources/SparkByte_Slides.pdf";

// veritcal timeline imports
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
//import WorkIcon from "@mui/icons-material/Work";
import SchoolIcon from "@mui/icons-material/School";
import CodeIcon from "@mui/icons-material/Code";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import "react-vertical-timeline-component/style.min.css";

function Projects() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // could be 'auto' instead of 'smooth'
    });
  };

  const scrollToBottom = (event) => {
    event.preventDefault();
    const targetId = event.currentTarget.getAttribute("href").substring(1);
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="project">
      <div className="project-header">
        <div className="project-header-split-wrapper">
          {windowWidth > 767 ? (
            <>
              <h1 className="project-header-left">My Projects!</h1>
              <Link to="/" className="project-header-right">
                Home
              </Link>
            </>
          ) : (
            <>
              <Link to="/" className="project-header-right">
                Home
              </Link>
              <h1 className="project-header-left">My Projects!</h1>
            </>
          )}
        </div>
        <p>
          These are the main projects I have worked on. Each highlights different parts of my skillset and is shown in the order I created them. The project titles link to the main project (like a deployed site), while the bottom of each project section includes supplementary links such as GitHub repos or presentations.
        </p>
        <p>
          If you want to jump down to my{" "}
          <a href="#skills-section" onClick={scrollToBottom}>
            skills section
          </a>{" "}
          just click {" "}
          <a href="#skills-section" onClick={scrollToBottom}>
            here.
          </a>{" "}
          
        </p>
      </div>
      <div className="project-timeline">
        <VerticalTimeline lineColor="#c4c4c4">
          {/* courseGenie */}
          <VerticalTimeline lineColor="#c4c4c4">
          {/* 116th Insight */}
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="April 2025 - May 2025"
            contentStyle={{ background: "#444", color: "#c4c4c4" }}
            contentArrowStyle={{ borderRight: "7px solid  #444" }}
            iconStyle={{
              background: "rgb(33, 120, 50)",
              color: "#eee",
              boxShadow: "0 0 0 4px #c4c4c4",
            }}
            icon={<SchoolIcon />}
          >
            <div style={{ color: "#eee" }}>
              <h3 className="vertical-timeline-element-title">
                
                  116th Insight: House Ratings & 2020 Contributions
              
              </h3>
              <h4 className="vertical-timeline-element-subtitle">
                Django, Python, HTML/CSS, Plotly
              </h4>
            </div>
            <p>
              Built a web app to explore leadership in the 116th House of Representatives. Used Django ListView & DetailView with filtering, authentication for user accounts, and allowed creating & editing reviews. Uploaded CSVs to populate donor records, visualized $200+ campaign contributions with Plotly, and implemented search & filter for large donor lists.
            </p>
            <p>
              <b>Features:</b> View & rate political leaders, see donation breakdowns, add missing Congress members with linked 2020 data, and explore top contributors. 
            </p>
            <p>
              <a 
                href="https://www.youtube.com/watch?v=5ur49vztUnI" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                Demo Video
              </a>
            </p>
          </VerticalTimelineElement>

          {/* SparkBytes */}
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="March 2025 - May 2025"
            contentStyle={{ background: "#444", color: "#c4c4c4" }}
            contentArrowStyle={{ borderRight: "7px solid  #444" }}
            iconStyle={{
              background: "rgb(33, 120, 50)",
              color: "#eee",
              boxShadow: "0 0 0 4px #c4c4c4",
            }}
            icon={<SchoolIcon />}
          >
            <div style={{ color: "#eee" }}>
                      <a 
            href="https://sparkbytes-git-main-jason-anghads-projects.vercel.app/" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <h3 className="vertical-timeline-element-title">
              SparkBytes: Free Food Map
            </h3>
          </a>
              <h4 className="vertical-timeline-element-subtitle">
                React, Next.js, Supabase, Mapbox, TypeScript, Tailwind CSS
              </h4>
            </div>
            <p>
              Developed a full-stack app where BU students & faculty post leftover food events on an interactive Mapbox map to prevent food waste. Implemented authentication with Supabase, role-based dashboards, modals for event creation & RSVP, and real-time data updates. 
            </p>
            <p>
              <b>PM Role:</b> Served as group Product Manager — led sprint planning & retros, managed Notion boards, was lead presenter, and guided technical direction while coding key features.
            </p>
            <p>
              <b>Collaborators:</b> Team of 3 other students.
            </p>
            <p>
              <a 
                href="https://github.com/Janghad/Git-commit--m-Team-4-" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                GitHub Repo
              </a> 
              | 
              <a 
                href={SB_Slides}
                target="_blank"
                rel="noopener noreferrer"
              >
                 Presentation
              </a>
            </p>
          </VerticalTimelineElement>

          {/* Unfollow Insight */}
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="February 2025"
            contentStyle={{ background: "#444", color: "#c4c4c4" }}
            contentArrowStyle={{ borderRight: "7px solid  #444" }}
            iconStyle={{
              background: "rgb(33, 120, 50)",
              color: "#eee",
              boxShadow: "0 0 0 4px #c4c4c4",
            }}
            icon={<CodeIcon />}
          >
            <div style={{ color: "#eee" }}>
              <h3 className="vertical-timeline-element-title">
                <a 
                  href="https://benbucaj.github.io/unfollow-insight/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  Unfollow Insight
                </a>
              </h3>
              <h4 className="vertical-timeline-element-subtitle">
                JavaScript, HTML, CSS
              </h4>
            </div>
            <p>
            I’ve always heard people complain about how hard it is to see who doesn’t follow them back on Instagram, so I built a lightweight tool that avoids a backend or requirements of any account information to keep things secure and users comfortable. It’s a privacy-friendly browser app that compares your Instagram followers and following lists from exported data. It reads local HTML files, pulls the usernames, and shows who isn’t following you back with direct profile links.
            </p>
            <p>
              <a 
                href="https://github.com/BenBucaj/unfollow-insight" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                GitHub Repo
              </a>
            </p>
          </VerticalTimelineElement>

          {/* Price Anchoring */}
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="November 2024 - December 2024"
            contentStyle={{ background: "#444", color: "#c4c4c4" }}
            contentArrowStyle={{ borderRight: "7px solid  #444" }}
            iconStyle={{
              background: "rgb(33, 120, 50)",
              color: "#eee",
              boxShadow: "0 0 0 4px #c4c4c4",
            }}
            icon={<SchoolIcon />}
          >
            <div style={{ color: "#eee" }}>
              <h3 className="vertical-timeline-element-title">
                <a href= {Price_Anchoring} target="_blank" rel="noopener noreferrer">
                  Price Anchoring Consumer Behavior Study
                </a>
              </h3>
              <h4 className="vertical-timeline-element-subtitle">
                Survey Data, Statistical Analysis, Business Analytics, Python, Pandas, Matplotlib
              </h4>
            </div>
            <p>
              Designed and executed an A/B test surveying over 100 Boston University students to study how price anchoring influences willingness to pay. Used Pandas to clean and structure survey responses, visualized patterns with Matplotlib, and ran OLS regressions in Statsmodels to statistically validate anchoring effects. Synthesized findings into a formal paper with actionable insights on consumer psychology.
            </p>
            <p>
              <b>Collaborators:</b> Team of  3 other students.
            </p>
            <p>
              <a 
                href= {PA_Slides}
                target="_blank" 
                rel="noopener noreferrer"
              >
                Presentation
              </a>
            </p>
          </VerticalTimelineElement>

          {/* World Happiness */}
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="October 2024 - December 2024"
            contentStyle={{ background: "#444", color: "#c4c4c4" }}
            contentArrowStyle={{ borderRight: "7px solid  #444" }}
            iconStyle={{
              background: "rgb(33, 120, 50)",
              color: "#eee",
              boxShadow: "0 0 0 4px #c4c4c4",
            }}
            icon={<SchoolIcon />}
          >
            <div style={{ color: "#eee" }}>
            <a href={Happiness_Slides} target="_blank" rel="noopener noreferrer">
              <h3 className="vertical-timeline-element-title">
                World Happiness ML
              </h3>
            </a>
              <h4 className="vertical-timeline-element-subtitle">
                Python, Pandas, scikit-learn
              </h4>
            </div>
            <p>
            Analyzed the World Happiness Report to identify key drivers of well-being and provide policy insights. Built and compared machine learning models including decision trees, logistic regression, K-nearest neighbors, Lasso, and random forests, achieving top accuracy with Random Forest at 96 percent. Used nested cross-validation to ensure robust results, finding GDP, family, health, and freedom to be the strongest contributors to happiness. This project highlights how multiple factors together shape well-being and offers a data-backed framework for developing sustainable policies.
            </p>
            <p>
              <b>Collaborators:</b> Team of 3 other students.
            </p>
            <p>
              <a 
                href="https://github.com/FilipLe/World-Happiness" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                GitHub Repo
              </a>
            </p>
          </VerticalTimelineElement>
        </VerticalTimeline>
          <VerticalTimelineElement
            iconStyle={{
              background: "rgb(33, 120, 50)",
              color: "#eee",
              boxShadow: "0 0 0 4px #c4c4c4",
            }}
            icon={<ArrowUpwardIcon />}
            iconOnClick={scrollToTop}
          ></VerticalTimelineElement>
        </VerticalTimeline>
      </div>
      <div className="project-skills" id="skills-section">
        <div className="project-skills-icons-wrapper">
          <h3>Languages and Frameworks</h3>
          <div className="project-skills-icons">
            {/* python */}
            <img
              src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/python/python-original.svg"
              alt="Python SVG"
            />
            {/* java */}
            <img
              src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/java/java-original.svg"
              alt="Java SVG"
            />
            {/* html */}
            <img
              src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/html5/html5-original.svg"
              alt="HTML SVG"
            />
            {/* CSS */}
            <img
              src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/css3/css3-original.svg"
              alt="CSS SVG"
            />
            {/* javascript */}
            <img
              src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/javascript/javascript-original.svg"
              alt="JavaScript SVG"
            />
            {/* react */}
            <img
              src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original.svg"
              alt="React SVG"
            />
            {/* angular */}
            <img
              src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/angular/angular-original.svg"
              alt="Angular SVG"
            />
            {/* ocaml */}
            <img
              src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/ocaml/ocaml-original.svg"
              alt="OCaml SVG"
            />
            {/* typescript */}
            <img
              src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/typescript/typescript-original.svg"
              alt="Typescript SVG"
            />
            {/* git */}
            <img
              src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/git/git-original.svg"
              alt="Git SVG"
            />
          </div>
          <p>
            Python, Java, HTML, CSS, JavaScript, Django, React, OCaml,
            Typescript, Git, SQL, NoSQL
          </p>
          <h3>Tools and Applications</h3>
          <div className="project-skills-icons">
            {/* github */}
            <img
              src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/github/github-original.svg"
              alt="GitHub SVG"
            />
            {/* jupyter */}
            <img
              src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/jupyter/jupyter-original.svg"
              alt="Jupyter SVG"
            />
            {/* mongodb */}
            <img
              src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/mongodb/mongodb-original.svg"
              alt="MongoDB SVG"
            />
            {/* mysql */}
            <img
              src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/mysql/mysql-original.svg"
              alt="MySQL SVG"
            />
            {/* postgresql */}
            <img
              src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/postgresql/postgresql-original.svg"
              alt="PostgreSQL SVG"
            />
            {/* vscode */}
            <img
              src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/vscode/vscode-original.svg"
              alt="Visual Studio code SVG"
            />
            {/* spyder */}
            <img
              src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/spyder/spyder-original.svg"
              alt="Spyder SVG"
            />
            {/* latex */}
            <img
              src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/latex/latex-original.svg"
              alt="LaTeX SVG"
            />
            {/* docker */}
            <img
              src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/docker/docker-original.svg"
              alt="Docker SVG"
            />
          </div>
          <p>
            GitHub, Jupyter, MongoDB, MySQL, PostgreSQL, Visual Studio Code,
            Spyder, LaTeX, Docker
          </p>
          <button
            className="project-skills-scroll-up"
            onClick={scrollToTop}
            style={{
              backgroundColor: "rgb(33, 120, 50)",
              color: "#eee",
              width: "100%",
              borderRadius: "0 0 20px 20px",
              // borderRadius: "0 20px",
              margin: "0 -1vw -1vh -1vw",
              padding: "2vh 1vw",
            }}
          >
            Jump to top
          </button>
        </div>
      </div>
    </div>
  );
}

export default Projects;
